import { useTranslation } from "react-i18next";
import { usePerms } from "../../hooks/usePerms";

// Checkbox group for the four platform permissions.
export const PermsPicker = ({ value = [], onChange, testId = "perms" }) => {
  const { t } = useTranslation();
  const { perms } = usePerms();
  const toggle = (perm) =>
    onChange(value.includes(perm) ? value.filter((p) => p !== perm) : [...value, perm]);

  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {perms.map((perm) => (
        <label
          key={perm}
          className={`neu-in flex cursor-pointer items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold ${
            value.includes(perm) ? "text-primary" : "text-muted-foreground"
          }`}
        >
          <input
            type="checkbox"
            className="h-4 w-4 accent-primary"
            checked={value.includes(perm)}
            onChange={() => toggle(perm)}
            data-testid={`${testId}-${perm}`}
          />
          {t(`staff.perms.${perm}`)}
        </label>
      ))}
    </div>
  );
};
